import { apiSlice } from '../../app/services/apiSlice'

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    // 요청유형(reqTySe) 별 요청분류 목록
    // - PC `/popup/serviceopreq/getReqCl`는 모바일 세션 컨텍스트에서 빈 응답이 와서
    //   SearchRequest가 쓰는 `/approval/serviceprogress/getReqCl`로 사용. 동일 SQL 호출(useAt='Y')
    getServReqReqCl: builder.query({
      query: ({ reqTySe } = {}) => ({
        url: '/approval/serviceprogress/getReqCl',
        params: { reqTySe, useAt: 'Y' },
      }),
      transformResponse: response => (Array.isArray(response) ? response : []),
    }),

    // 요청분류(reqCl) 별 요청서비스 목록
    getServReqServId: builder.query({
      query: ({ coId, reqCl } = {}) => ({
        url: '/popup/serviceopreq/getServId',
        params: { coId, reqCl },
      }),
      transformResponse: response => response ?? [],
    }),

    // 요청 등록 (PC opReq_popup → /reqProc)
    addServiceRequest: builder.mutation({
      query: formData => ({
        url: '/popup/serviceopreq/reqProc',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Req'],
    }),
  }),
})

export const {
  useGetServReqReqClQuery,
  useGetServReqServIdQuery,
  useAddServiceRequestMutation,
} = extendedApiSlice